import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { ImpactedStakeholderListComponent } from './impacted-stakeholder-list/impacted-stakeholder-list.component'

export const impactedStakeholderRoutes: Route[] = [
  {
    path: 'impacted-stakeholders',
    component: ImpactedStakeholderListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'impacted-stakeholders/:id/edit',
    redirectTo: 'impacted-stakeholders/:id',
    pathMatch: 'full'
  },
  {
    path: 'impacted-stakeholders/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'ImpactedStakeholder',
        nameSingular: 'Impacted Stakeholder',
        namePlural: 'Impacted Stakeholders',
        path: 'impacted-stakeholders',
        slug: 'taxonomies/impacted-stakeholders',
        title: 'Impacted Stakeholders'
      }),
      permission: 'readTaxonomies'
    }
  }
]
